var _classCallCheck = require("D:/VSCodeRepo/schatzkammer_web/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("D:/VSCodeRepo/schatzkammer_web/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("D:/VSCodeRepo/schatzkammer_web/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("D:/VSCodeRepo/schatzkammer_web/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("D:/VSCodeRepo/schatzkammer_web/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Declaration = require('../declaration');

var Filter = /*#__PURE__*/function (_Declaration) {
  "use strict";

  _inherits(Filter, _Declaration);

  var _super = _createSuper(Filter);

  function Filter() {
    _classCallCheck(this, Filter);

    return _super.apply(this, arguments);
  }

  _createClass(Filter, [{
    key: "check",
    value:
    /**
     * Check is it Internet Explorer filter
     */
    function check(decl) {
      var v = decl.value;
      return !v.toLowerCase().includes('alpha(') && !v.includes('DXImageTransform.Microsoft') && !v.includes('data:image/svg+xml');
    }
  }]);

  return Filter;
}(Declaration);

Filter.names = ['filter'];
module.exports = Filter;